export default "__VITE_ASSET__Dc8j5s3p__"